import { MessageBar, MessageBarButton, MessageBarType } from "@fluentui/react";
import styles from './MessageBar.module.css'
import { useState } from "react";

export const MessageBarComponent = () => {
    const [showMessageBar, setShowMessageBar] = useState(true)

    return (showMessageBar ? (
        <div className={styles.messageWrapper}>
            <MessageBar
                styles={{
                    root: {
                        maxWidth: '725px',
                        minHeight: '71px',
                        margin: '16px auto 0',
                        borderRadius: '8px',
                        border: '1px solid #E3BB5C',
                        background: 'rgba(250, 221, 153, 0.39)',
                        '@media screen and (max-width: 480px)': {
                            height: 'auto',
                            margin: '10px 0 0',
                        },
                    },
                    iconContainer: {
                        margin: '16px 0 0 16px'
                    },
                    text: {
                        marginTop: '16px'
                    },
                }}
                messageBarIconProps={{ iconName: 'CustomInfoIcon' }}
                dismissIconProps={{ iconName: 'CustomCloseIcon' }}
                messageBarType={MessageBarType.warning}
                isMultiline={true}
                onDismiss={() => setShowMessageBar(false)}
                dismissButtonAriaLabel="Close"
            >
                <div className={styles.messageContent}>
                    <div>
                        <strong style={{ display: 'block', marginBottom: 4 }}>This is the SAMMY testing environment.</strong>
                        <span>Limit all used information to FOUO classification. If you're here by mistake, please open</span>
                    </div>
                    <MessageBarButton
                        styles={{
                            root: {
                                width: '160px',
                                marginTop: '7px',
                                padding: '0 8px',
                                borderRadius: '6px',
                                border: '1px solid #C6D8EF',
                                background: '#FFF',
                            }
                        }}
                        onClick={() => window.open('https://sam.imfconnect.org/', '_blank', 'noopener,noreferrer')}>
                        Official Version
                    </MessageBarButton>
                </div>
            </MessageBar>
        </div>)
        : null
    )
};